import React from "react";
import { RouterParams } from "../router/RouterParams";

import { CfdiForm } from "../cfdis/CfdiForm";

export default function CfdiNonRelatedForm({ match }: RouterParams) {

    const uuidNonRelated = match.params.uuidNonRelated;
    const mode = match.params.mode;

    return (
        <CfdiForm mode={mode} nonRelatedCfdiUuid={uuidNonRelated} />
    );
}